<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
    <el-dialog :title="$t('im.upload.uploadTitle')" :visible.sync="exportsVisible" :before-close="closePop">
      <el-upload ref="upload" drag
                 :limit=limitNum
                 :auto-upload="false"
                 accept=".xlsx"
                 :action="UploadUrl()"
                 :before-upload="beforeUploadFile"
                 :on-change="fileChange"
                 :on-exceed="exceedFile"
                 :on-success="handleSuccess"
                 :on-error="handleError"
                 :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">{{$t('im.upload.uploadTipPrefix')}}<em>{{$t('im.upload.uploadTipSuffix')}}</em>
        </div>
        <div class="el-upload__tip" slot="tip">{{$t('im.upload.uploadNumTip')}}</div>
      </el-upload>
      <br/>
      <a href="https://sc.tfejy.com/source/IM/知识导入模板.xlsx"
         class="el-button el-button--success el-button--default is-plain">{{$t('im.upload.downExample')}}</a>
      <el-button size="small" type="primary" @click="uploadFile">{{$t('im.upload.uploadButton')}}</el-button>
    </el-dialog>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import download from '@/utils/download'
  //接口地址url的统一管理
  import URL from '@/api/im/url'
  import { getQueryString, localRead } from '@/utils/tools'
  import Qs from 'qs'
  import originAxios from 'axios'
  import { getToken } from '@/utils/auth'

  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    async created() {
      for (const i in this.businessGroupData) {
        let code = this.businessGroupData[i].code
        let name = this.businessGroupData[i].name
        this.bizCodeObj[code] = name
        this.bizCodes.push(code)
      }
      for (const i in this.langList) {
        let code = this.langList[i].id
        let name = this.langList[i].name
        this.localeObj[code] = name
        this.locales.push(code)
      }
      for (const i in this.enableType) {
        let code = this.enableType[i].value
        let name = this.enableType[i].title
        this.enableObj[code] = name
      }
      for (const i in this.recommendType) {
        let code = this.recommendType[i].value
        let name = this.recommendType[i].title
        this.recommendObj[code] = name
      }
      for (const i in this.categoryType) {
        let code = this.categoryType[i].value
        let name = this.categoryType[i].title
        this.categoryCodeObj[code] = name
      }
      //加载分类
      await this.$axios.post(URL.knowledgeCategory.knowledgeCategoryList, { companyId: this.userInfo.companyId }, {
        headers: {
          'isAjax': 'true',
          'Content-Type': 'application/json'
        }
      }).then(res => {
        if (res.code == 0 && !!res.result) {
          let result = res.result
          for (const i in result) {
            let code = result[i].id
            let name = result[i].name
            this.categoryObj[code] = name
          }
          this.$refs.childTable.defaultGetData({
            companyId: this.userInfo.companyId,
            bizCodes: this.bizCodes,
            locales: this.locales
          })
        }
      })
      this.updateData = {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          { title: window.$t('im.knowledgeList.title'), field: 'title', required: true },
          {
            title: window.$t('im.knowledgeList.keywords'),
            field: 'keywords',
            placeholder: window.$t('im.knowledgeList.keywordsPlaceholder')
          },
          {
            title: window.$t('im.common.bizCode'),
            field: 'bizCode',
            type: 2,
            required: true,
            optionList: this.bizCodeObj
          },
          {
            title: window.$t('im.common.locale'),
            field: 'locale',
            type: 2,
            required: true,
            optionList: this.localeObj
          },
          {
            title: window.$t('im.knowledgeList.category'),
            field: 'categoryCode',
            type: 2,
            required: true,
            optionList: this.categoryCodeObj
          },
          {
            title: window.$t('im.knowledgeList.weight'),
            field: 'weight',
            required: true,
            textType: 'number',
            isNumber: true
          },
          {
            title: window.$t('im.knowledgeList.content'),
            field: 'content',
            type: 6,
            required: true,
            uploadUrl: this.uploadMultiUrl
          },
          {
            title: window.$t('im.common.enable'),
            field: 'enable',
            type: 2,
            required: true,
            optionList: this.enableObj,
            isNumber: true,
            data: 1
          }
        ]
      },
        this.formData.cols = [
          {
            title: window.$t('im.common.companyId'),
            field: 'companyId',
            hidden: 'true',
            data: this.userInfo.companyId
          },
          { title: window.$t('im.knowledgeList.title'), field: 'title' },
          { title: window.$t('im.common.bizCode'), field: 'bizCode', type: 2, optionList: this.bizCodeObj },
          { title: window.$t('im.common.locale'), field: 'locale', type: 2, optionList: this.localeObj },
          {
            title: window.$t('im.knowledgeList.category'),
            field: 'categoryCode',
            type: 2,
            optionList: this.categoryCodeObj
          },
          {
            title: window.$t('im.common.enable'),
            field: 'enable',
            type: 2,
            optionList: this.enableObj,
            isNumber: true
          },
          {
            title: window.$t('im.knowledgeList.createDateRange'),
            field: 'createDateRange',
            type: 6,
            isArray: true,
            format: 'yyyy-MM-dd HH:mm:ss',
            startEndParam: ['queryStartTime', 'queryEndTime']
          },
          { click: window.$t('im.bt.search') },
          { click: window.$t('im.bt.reset') },
          { click: window.$t('im.bt.add') },
          { click: window.$t('im.knowledgeList.upload') },
          { click: window.$t('im.knowledgeList.export') }
        ]
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick(clickName, row) {
        if (clickName == 'update') {
          this.$refs.childUpdate.open(row)
        } else if (clickName == 'delete') {
          this.dataDelete(URL.knowledge.knowledgeDelete, { id: row.id }, res => {
            if (res.code == 0) {
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        } else if (clickName == 'enableOrNot') {
          row['enable'] = row['enable'] == 0 ? 1 : 0
          this.dataChanage(URL.knowledge.knowledgeUpdate, row, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data) {
        if ('查询' == clickName || window.$t('im.bt.search') == clickName) {
          data['bizCodes'] = this.bizCodes
          data['locales'] = this.locales
          this.queryData = data
          this.$refs.childTable.defaultGetData(data)
        } else if ('新增' == clickName || window.$t('im.bt.add') == clickName) {
          this.$refs.childUpdate.open()
        } else if ('重置' == clickName || window.$t('im.bt.reset') == clickName) {
          this.formData.cols = [
            {
              title: window.$t('im.common.companyId'),
              field: 'companyId',
              hidden: 'true',
              data: this.userInfo.companyId
            },
            { title: window.$t('im.knowledgeList.title'), field: 'title' },
            { title: window.$t('im.common.bizCode'), field: 'bizCode', type: 2, optionList: this.bizCodeObj },
            { title: window.$t('im.common.locale'), field: 'locale', type: 2, optionList: this.localeObj },
            {
              title: window.$t('im.knowledgeList.category'),
              field: 'categoryCode',
              type: 2,
              optionList: this.categoryCodeObj
            },
            {
              title: window.$t('im.common.enable'),
              field: 'enable',
              type: 2,
              optionList: this.enableObj,
              isNumber: true
            },
            {
              title: window.$t('im.knowledgeList.createDateRange'),
              field: 'createDateRange',
              type: 6,
              isArray: true,
              format: 'yyyy-MM-dd HH:mm:ss',
              startEndParam: ['queryStartTime', 'queryEndTime']
            },
            { click: window.$t('im.bt.search') },
            { click: window.$t('im.bt.reset') },
            { click: window.$t('im.bt.add') },
            { click: window.$t('im.knowledgeList.upload') },
            { click: window.$t('im.knowledgeList.export') }
          ]
          this.$refs.childForm.queryListData()
        } else if ('列表显示隐藏' == clickName || window.$t('im.bt.hideOrNo') == clickName) {
          this.pageData.isShow = !this.pageData.isShow
        } else if ('批量导入' == clickName || window.$t('im.knowledgeList.upload') == clickName) {
          this.exportsVisible = true
          this.fileList = []
        } else if ('导出知识' == clickName || window.$t('im.knowledgeList.export') == clickName) {
          data['bizCodes'] = this.bizCodes
          data['locales'] = this.locales
          download.exportExcel(URL.knowledge.knowledgeExport, data, window.$t('im.knowledgeList.exportName'))
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model) {
        //移除属性
        if (!!model){
          delete model.searchNum
          delete model.usefulNum
          delete model.uselessNum
        }
        //根据是否包含id更新还是添加
        if (!!model.id) {
          this.dataChanage(URL.knowledge.knowledgeUpdate, model, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.dataChanage(URL.knowledge.knowledgeAdd, model, res => {
            if (res.code == 0) {
              this.$refs.childUpdate.close()
              this.$message.success('suc')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      dataChanage(url, option, suc, fail) {
        option['operatorName'] = this.userInfo.displayName
        option['operator'] = this.userInfo.id
        option['companyId'] = this.userInfo.companyId
        this.$axios.post(url, option, {
          headers: {
            'isAjax': 'true',
            'Content-Type': 'application/json'
          }
        }).then(res => {
          this.$refs.childTable.defaultGetData(this.queryData)
          if (suc && (typeof suc == 'function')) suc(res)
        }).catch(res => {
          if (fail && (typeof fail == 'function')) fail(res)
        })
      },
      dataDelete(url, option, suc, fail) {
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
          this.$refs.childTable.defaultGetData(this.queryData)
          if (suc && (typeof suc == 'function')) suc(res)
        }).catch(res => {
          if (fail && (typeof fail == 'function')) fail(res)
        })
      },
      getDesc(array, value) {
        let res = ''
        array.forEach(item => {
          if (item.value === value) {
            res = item.title
            return res
          }
        })
        return res
      },
      brushBusinessGroup(data) {
        for (const i in this.businessGroupData) {
          if (this.businessGroupData[i].code == data) {
            return this.businessGroupData[i].name
          }
        }
        return ''
      },
      brushLocale(data) {
        for (const i in this.langList) {
          if (this.langList[i].id == data) {
            return this.langList[i].name
          }
        }
        return ''
      },
      brushCategory(data) {
        for (const i in this.categoryObj) {
          if (i == data) {
            return this.categoryObj[i]
          }
        }
        return ''
      },
      // 文件超出个数限制时的钩子
      exceedFile(files, fileList) {
        this.$message.warning(window.$t('im.upload.numPrefix') + `${this.limitNum}` + window.$t('im.upload.numMid') + `${files.length + fileList.length}` + window.$t('im.upload.numSuffix'))
      },
      // 文件状态改变时的钩子
      fileChange(file, fileList) {
        this.fileList.push(file.raw)
      },
      // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
      beforeUploadFile(file) {
        let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
        let size = file.size / 1024 / 1024
        if (extension !== 'xlsx') {
          this.$message.warning(window.$t('im.upload.excelTipOne') + '')
        }
        if (size > 10) {
          this.$message.warning(window.$t('im.upload.excelTipTwo') + '')
        }
      },
      // 文件上传成功时的钩子
      handleSuccess(res, file, fileList) {
        this.fileList = []
        this.$message.success(window.$t('im.upload.success') + '')
      },
      // 文件上传失败时的钩子
      handleError(err, file, fileList) {
        this.$message.error(window.$t('im.upload.fail') + '')
      },
      UploadUrl: function() {
        // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
        return ''
      },
      uploadFile() {
        if (this.fileList.length === 0) {
          this.$message.warning(window.$t('im.upload.pleaseUpload') + '')
        } else {
          let form = new FormData()
          let fileObj = this.fileList[0]
          form.append('file', fileObj)
          form.append(`companyId`, this.userInfo.companyId)
          form.append(`operator`, this.userInfo.id)
          form.append(`operatorName`, this.userInfo.displayName)
          originAxios.post(URL.knowledge.knowledgeImport, form, {
            headers: {
              'Authorization': getToken(getQueryString('label')),
              'Content-Type': 'multipart/form-data'
            },
            timeout: 30000
          }).then(
            res => {
              if (res.data.code == 0) {
                this.$message.success(window.$t('im.upload.success') + '')
                this.fileList = []
                this.$refs.childTable.defaultGetData(this.queryData)
              } else {
                this.$message.error(window.$t('im.upload.fail') + '')
              }
            }, err => {
              this.$message.error(window.$t('im.upload.fail') + '')
            })
        }
      }, /*关闭弹窗*/
      closePop() {
        this.exportsVisible = false
        this.fileList = []
        this.$refs.upload.clearFiles()
      }
    },
    data() {
      return {
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
        langList: JSON.parse(localRead('locale_IM')),  //语言列表
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        exportsVisible: false,
        limitNum: 1,  // 上传excell时，同时允许上传的最大数
        fileList: [],   // excel文件列表
        uploadMultiUrl: process.env.VUE_APP_BASE_API + '/serviceBusiness/api/upload/uploadMulti',  //上传文件文件地址
        enableType: [
          { value: 0, title: window.$t('im.common.enableNo') },
          { value: 1, title: window.$t('im.common.enableYes') }
        ],
        recommendType: [
          { value: 0, title: window.$t('im.knowledgeList.recommendNo') },
          { value: 1, title: window.$t('im.knowledgeList.recommendYes') }
        ],
        categoryType: [
          {value: "open", title: window.$t('im.knowledgeList.open') },
          {value: "deposit", title: window.$t('im.knowledgeList.deposit') },
          {value: "withdraw", title: window.$t('im.knowledgeList.withdraw') },
          {value: "transaction", title: window.$t('im.knowledgeList.transaction') },
          {value: "activities", title: window.$t('im.knowledgeList.activities') }
        ],
        bizCodeObj: {},
        localeObj: {},
        enableObj: {},
        categoryObj: {},
        categoryCodeObj: {},
        recommendObj: {},
        deleteIds: '',
        queryData: {},
        bizCodes: [],
        locales: [],
        /*新增或更新*/
        updateData: {},
        /*from查询表单*/
        formData: {
          hasLable: true,
          cols: []
        },
        /*table生成*/
        pageData: {
          isShow: false,
          queryUrl: URL.knowledge.knowledgeList, //请求路径和参数
          selection: false,
          sequence: false,
          method: 'post-json',
          cols: [
            { title: 'ID', field: 'id' },
            { title: window.$t('im.knowledgeList.title'), field: 'title' },
            { title: window.$t('im.knowledgeList.keywords'), field: 'keywords' },
            {
              title: window.$t('im.common.bizCode'), field: 'bizCode', render: (data) => {
                return this.brushBusinessGroup(data)
              }
            },
            {
              title: window.$t('im.common.locale'), field: 'locale', render: (data) => {
                return this.brushLocale(data)
              }
            },
            {
              title: window.$t('im.knowledgeList.category'), field: 'categoryCode', render: (data) => {
                return this.getDesc(this.categoryType,data)
              }
            },
            { title: window.$t('im.knowledgeList.weight'), field: 'weight' },
            { title: window.$t('im.knowledgeList.searchNum'), field: 'searchNum' },
            { title: window.$t('im.knowledgeList.usefulNum'), field: 'usefulNum' },
            { title: window.$t('im.knowledgeList.uselessNum'), field: 'uselessNum' },
            {
              title: window.$t('im.common.enable'), field: 'enable', render: (data) => {
                return this.getDesc(this.enableType, data)
              }
            },
            { title: window.$t('im.knowledgeList.operatorName'), field: 'operatorName' },
            { title: window.$t('im.common.createDate'), field: 'createDate' },
            { title: window.$t('im.common.updateDate'), field: 'updateDate' },
            {
              title: window.$t('im.bt.operator'), width: 220, btnClick: [{
                name: (data, full) => {
                  return full.enable == 0 ? window.$t('im.common.enableYes') : window.$t('im.common.enableNo')
                }, size: 'mini', click: 'enableOrNot', type: 'primary', confirm: true
              },
                { name: window.$t('im.bt.update'), size: 'mini', click: 'update', type: 'primary' },
                { name: window.$t('im.bt.delete'), size: 'mini', click: 'delete', type: 'primary' }]
            }
          ]
        }
      }
    }
  }
</script>
